// extracted by mini-css-extract-plugin
export default {"Grid":"index-module_Grid_w-CBP","container":"index-module_container_sRW-P"};